<template>
  <form
    class="sm-form sm-form__extension"
    @submit.prevent="handleSubmit"
  >
    <h4>{{title}}</h4>
    <div class="sm-form__extension-flex">
      <input-text
        v-model="formData.extension"
        :label="'Extension'"
        :class="{
          'disabled': initData && Object.keys(initData).length
        }"
        v-validate="'required|numeric'"
        name="extension"
        data-vv-as="Extension"
        :error="errors.first('extension')"
      />
      <input-text
        v-model="formData.name"
        :label="'Name'"
        v-validate="'required'"
        name="name"
        data-vv-as="Extension name"
        :error="errors.first('name')"
      />
    </div>
    <phone-input
      v-model="formData.forward_to_phone_number"
      :start_val="formData.forward_to_phone_number"
      :label="'Phone'"
      :show_errors="true"
    />

    <div class="sm-form__extension-flex">
      <btn-block
        :text="btnText"
        :class="'sm-btn--small'"
        type="submit"
      />
      <btn-block 
        :class="'sm-btn--small sm-btn--grey-cut'" 
        :text="'Cancel'"
        type="button"
        @click="$emit('cancel')"
      />
    </div>
  </form>
</template>

<script>
import InputText from '@/components/InputText';
import PhoneInput from '@/components/PhoneInput';

export default {
  name: 'form-extension',
  components: {
    'input-text': InputText,
    'phone-input': PhoneInput,
  },
  props: {
    title: {
      type: String,
      required: true
    },
    btnText: {
      type: String,
      default: true
    },
    initData: {
      type: Object,
      default: () => new Object()
    }
  },
  data() {
    return {
      formData: {
        extension: '',
        name: '',
        forward_to_phone_number: ''
      }
    };
  },
  created() {
    if (this.initData && Object.keys(this.initData).length)
      Object.keys(this.formData).forEach(key => {
        if (this.initData.hasOwnProperty(key))
          this.formData[key] = this.initData[key];
      });
  },
  methods: {
    handleSubmit()  {
      this.$validator.validate()
        .then(valid => {
          if (!valid || !this.formData.forward_to_phone_number.length)
            return;

          this.$emit('submit', this.formData);
        });
    }
  }
}
</script>